import _ from "lodash";
import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import { Link } from "react-router";

import { routes, url, path } from "oo-routes";
import PageOverlay from "sp-components/components/PageOverlay";

import HomePageHero from "./HomePageHero";
import CareersHero from "./CareersHero";

import "./styles";

export default class NavBar2 extends React.Component {
  static propTypes = {
    landing: PropTypes.bool,
  };

  state = {
    menuActive: false,
  };

  setMenuActive = (menuActive) => () => {
    this.setState({ menuActive });
  };

  render() {
    const { user, landing, careers } = this.props;
    const ecommerceUser = user && (user.shopify || user.wooCommerce);
    return (
      <div className={classnames("NavBar2", { landing, careers })}>
        {(landing || careers) && (
          <div className="sp-index--video-container">
            {landing && (
              <video
                className="sp-video sp-video--index sp-desktop-only"
                preload="auto"
                autoPlay="true"
                loop="true"
                muted="muted"
              >
                <source
                  src="https://s3-us-west-2.amazonaws.com/oo-prod/public/assets/homepage-new.mp4"
                  type="video/mp4"
                />
              </video>
            )}
            {careers && (
              <video
                className="sp-video sp-video--index sp-desktop-only"
                preload="auto"
                autoPlay="true"
                loop="true"
                muted="muted"
              >
                <source
                  src="https://s3-us-west-2.amazonaws.com/oo-prod/public/assets/career.webm"
                  type="video/webm"
                />
                <source
                  src="https://s3-us-west-2.amazonaws.com/oo-prod/public/assets/career.mp4"
                  type="video/mp4"
                />
              </video>
            )}
          </div>
        )}
        <div className="ui container p-v-1_5">
          <div className="ui fluid menu b-a-n">
            <div className="item p-a-0">
              {ecommerceUser ? (
                <a href={url("ecommerce", routes.ecommerce.dashboard.base)}>
                  <img
                    className="ui image small sp-logo"
                    src={require("../../assets/logos/sp-logo-white.svg")}
                  />
                </a>
              ) : (
                <Link to={routes.website2.home.base}>
                  <img
                    className="ui image small sp-logo"
                    src={require("../../assets/logos/sp-logo-white.svg")}
                  />
                </Link>
              )}
            </div>
            <div className="right menu computer-only">
              <h5 className="item m-a-0 fw-700">
                <a href={url("website", routes.website2.home.pricing)}>
                  PRICING
                </a>
              </h5>
              <h5 className="item m-a-0 fw-700">
                <a href={url("website", routes.website2.home.catalog)}>
                  CATALOG
                </a>
              </h5>
              <h5 className="item m-r-2 m-v-0 m-l-0 fw-700">
                <a href={url("website", routes.website2.home.api)}>API</a>
              </h5>
              {user ? (
                <h5 className="item m-a-0 fw-700">
                  <a
                    href={url("manager", routes.manager2.base)}
                    className="ui white inverted basic button p-v-1"
                  >
                    MY ACCOUNT
                  </a>
                </h5>
              ) : (
                <h5 className="item m-a-0 fw-700">
                  <a
                    href={url("website", routes.website.auth.login)}
                    className="ui white inverted basic button p-v-1"
                  >
                    LOG IN
                  </a>
                </h5>
              )}
            </div>
            <div className="right menu tablet-only mobile-only">
              <a
                className="item m-a-0 fs-2 p-a-0"
                onClick={this.setMenuActive(true)}
              >
                <i className="sidebar icon m-a-0" />
              </a>
            </div>
          </div>
        </div>
        {landing && <HomePageHero user={user} />}
        {careers && <CareersHero />}

        <PageOverlay
          anchor="right"
          className="ui active dimmer"
          fluid
          active={this.state.menuActive}
          style={{ top: 0 }}
          animationDuration={200}
        >
          <div className="OverlayMenu">
            <div className="p-a-1_5">
              <div className="ui two column grid">
                <div className="left aligned middle aligned column">
                  <div className="ui image">
                    <img
                      src={require("sp-components/assets/images/sp_logo.png")}
                    />
                  </div>
                </div>
                <div className="right aligned middle aligned column">
                  <i
                    className="i cancel icon m-r-0"
                    onClick={this.setMenuActive(false)}
                  />
                </div>
              </div>
            </div>
            <div className="ui divider m-v-0" />
            <div
              className="left-aligned p-a-1_5"
              onClick={this.setMenuActive(false)}
            >
              <a
                href={url("website", routes.website2.home.pricing)}
                className="link fs-4 sp-primary-text-color d-b m-b-2"
              >
                Pricing
              </a>
              <a
                href={url("website", routes.website2.home.catalog)}
                className="link fs-4 sp-primary-text-color d-b m-b-2"
              >
                Catalog
              </a>
              <a
                href={url("website", routes.website2.home.api)}
                className="link fs-4 sp-primary-text-color d-b m-b-2"
              >
                API
              </a>
            </div>
            <div className="p-v-1 p-h-1_5">
              <a
                href={url("website", routes.website.auth.login)}
                className="ui fluid inverted basic primary button m-b-1_5"
              >
                LOG IN
              </a>
              <a
                href={url("website", routes.website.auth.register)}
                className="ui fluid primary button"
              >
                GET STARTED
              </a>
            </div>
          </div>
        </PageOverlay>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/NavBar2/index.jsx